import {
  postSaleEntryRoutes,
  postSaleMainRoutes,
  postSaleReturnRoutes,
} from './routeGroups/postSaleRoutes';
import { nucleoRoutes } from './routeGroups/nucleoRoutes';
import {
  supportDashboardRoutes,
  supportSheetRoutes,
} from './routeGroups/supportRoutes';
import { brokerRoutes } from './routeGroups/brokerRoutes';
import { financeRoutes } from './routeGroups/financeRoutes';
import {
  salesCoreRoutes,
  salesCreationRoutes,
} from './routeGroups/salesWorkflowRoutes';
import { salesPartyRoutes } from './routeGroups/salesPartyRoutes';
import { salesPendingRoutes } from './routeGroups/salesPendingRoutes';

export const routes = [
  ...postSaleEntryRoutes,
  ...nucleoRoutes,
  ...supportDashboardRoutes,
  ...brokerRoutes,
  ...supportSheetRoutes,
  ...financeRoutes,
  ...salesCoreRoutes,
  ...postSaleReturnRoutes,
  ...salesCreationRoutes,
  ...salesPartyRoutes,
  ...salesPendingRoutes,
  ...postSaleMainRoutes,
];
